import { render } from "./HeroiconsSolidUpload.vue?vue&type=template&id=fdea4efe"
const script = {}

import exportComponent from "/home/www/harixx_test/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidUpload.vue"]])

export default __exports__